module.exports = __webpack_public_path__ + "static/media/xk.bd62029e.svg";